/**
 * Ícone de lápis (line-icon) — C-75. Mesmo padrão do `PhoneIcon` do Header:
 * SVG com `stroke="currentColor"`, então herda a cor do botão (discreto em
 * repouso, amarelo no hover). Substitui o emoji ✏️, que renderiza colorido.
 */
export function PencilIcon({ size = 14, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      style={{ display: 'inline-block', verticalAlign: '-0.15em', flexShrink: 0 }}
    >
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </svg>
  );
}
